/* @ngInject */
const format = () => {
  const self = {}

  self.user = (_owner) => {
    return _owner
  }

  self.server = (_owner) => {
    return _owner
  }

  return self
}

export default format



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/services/format.service.js